export const createMaybeDebugFn =
  (enabled = false) =>
  () => {
    if (enabled) {
      // eslint-disable-next-line no-debugger
      debugger
    }
  }
